import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import Flow43_3Table from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const Flow43_3 = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("DISPOSAL_43_3") || "Disposal"}
        subDescription={t("DISPOSAL_43_3_DESC") || "This refers to transporting the waste fraction that cannot be recovered to its final disposal location, such as a landfill or incineration plant. It includes distances, fuel use, and transport emissions associated with delivering waste to its final treatment site."}
        isNormal={true}
        number={"43.3"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`flow-43-3-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <Flow43_3Table productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default Flow43_3;

